/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FieldRefDto } from './FieldRefDto';
import type { NestedStringNullableFilterDto } from './NestedStringNullableFilterDto';
export type StringNullableFilterDto = {
  /**
   * Equals filter for nullable string values
   */
  equals?: string | null | FieldRefDto;
  /**
   * In filter for nullable string values
   */
  in?: Array<string> | null | FieldRefDto;
  /**
   * Not in filter for nullable string values
   */
  notIn?: Array<string> | null | FieldRefDto;
  /**
   * Less than filter for nullable string values
   */
  lt?: string | FieldRefDto;
  /**
   * Less than or equal filter for nullable string values
   */
  lte?: string | FieldRefDto;
  /**
   * Greater than filter for nullable string values
   */
  gt?: string | FieldRefDto;
  /**
   * Greater than or equal filter for nullable string values
   */
  gte?: string | FieldRefDto;
  /**
   * Contains filter for nullable string values
   */
  contains?: string | FieldRefDto;
  /**
   * Starts with filter for nullable string values
   */
  startsWith?: string | FieldRefDto;
  /**
   * Ends with filter for nullable string values
   */
  endsWith?: string | FieldRefDto;
  /**
   * Query mode for case sensitivity
   */
  mode?: StringNullableFilterDto.mode;
  /**
   * Not filter for nullable string values
   */
  not?: string | null | NestedStringNullableFilterDto;
};
export namespace StringNullableFilterDto {
  /**
   * Query mode for case sensitivity
   */
  export enum mode {
    DEFAULT = 'default',
    INSENSITIVE = 'insensitive',
  }
}
